import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { clearEdit, fetchJob } from "../features/job/jobSlice";
import { createJob, editJob } from "../features/jobs/jobsSlice";
import { formatLocalToDate, formatDateToLocal, removeComa, thousandSeparator } from "../utils/common";


export default function AddOrUpdateJob() {
	const { editing } = useSelector(state => state.job);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { jobId } = useParams() || {};
	
	const [title, setTitle] = useState("");
	const [type, setType] = useState("");
	const [salary, setSalary] = useState("");
	const [deadline, setDeadline] = useState("");

	const [editMode, setEditMode] = useState(false);

	useEffect(() => {
		if (jobId !== undefined && editing?.id) {
			setEditMode(true);

			setTitle(editing.title);
			setType(editing.type);
			setSalary(removeComa(editing.salary));
			setDeadline(formatLocalToDate(editing.deadline));
		}
		else if (jobId) {
			// user reloaded page while edit
			setEditMode(true);
			dispatch(fetchJob(jobId));
		}
		else { 
			// user clicked on new-job while editing
			setEditMode(false);
			setTitle("");
			setType("");
			setSalary("");
			setDeadline(formatLocalToDate(""));
		}
	}, [editing, jobId, dispatch]);

	const handleFormSubmit = (e) => {
		e.preventDefault();

		let jobData = {
			title,
			type,
			salary: thousandSeparator(salary),
			deadline: formatDateToLocal(deadline)
		};
		if (editMode) {
			dispatch(editJob({id: jobId, jobData}));
		}
		else {
			dispatch(createJob(jobData));
		}

		dispatch(clearEdit());
		navigate("/");
	}

	return (
		<>
			<h1 className="mb-10 text-center section-title">{editMode ? 'Edit Job' : 'Add New Job'}</h1>

			<div className="max-w-3xl mx-auto">
				<form onSubmit={handleFormSubmit} className="space-y-6">
					<div className="fieldContainer">
						<label
							htmlFor="lwsJobTitle"
							className="text-sm font-medium text-slate-300"
						>
							Job Title
						</label>
						<select 
							value={title}
							onChange={(e) => setTitle(e.target.value)}
							id="lwsJobTitle"
							name="lwsJobTitle"
							autoComplete="lwsJobTitle"
							required
						>
							<option value="" hidden>
								Select Job
							</option>
							<option value='Software Engineer'>Software Engineer</option>
							<option value='Software Developer'>Software Developer</option>
							<option value='Full Stack Developer'>Full Stack Developer</option>
							<option value='MERN Stack Developer'>MERN Stack Developer</option>
							<option value='DevOps Engineer'>DevOps Engineer</option>
							<option value='QA Engineer'>QA Engineer</option>
							<option value='Product Manager'>Product Manager</option>
							<option value='Social Media Manager'>Social Media Manager</option>
							<option value='Senior Executive'>Senior Executive</option>
							<option value='Junior Executive'>Junior Executive</option>
							<option value='Android App Developer'>Android App Developer</option>
							<option value='IOS App Developer'>IOS App Developer</option>
							<option value='Frontend Developer'>Frontend Developer</option>
							<option value='Frontend Engineer'>Frontend Engineer</option>
							<option value='Backend Developer'>Backend Developer</option>
							<option value='Web Developer'>Web Developer</option>
						</select>
					</div>
					<div className="fieldContainer">
						<label htmlFor="lwsJobType">Job Type</label>
						<select
							value={type}
							onChange={(e) => setType(e.target.value)}
							id="lwsJobType"
							name="lwsJobType"
							autoComplete="lwsJobType"
							required
						>
							<option value="" hidden>
								Select Job Type
							</option>
							<option value='Full Time'>Full Time</option>
							<option value='Internship'>Internship</option>
							<option value='Remote'>Remote</option>
						</select>
					</div>

					<div className="fieldContainer">
						<label htmlFor="lwsJobSalary">Salary</label>
						<div className="flex border rounded-md shadow-sm border-slate-600">
							<span className="input-tag">BDT</span>
							<input
								value={salary}
								onChange={(e) => setSalary(e.target.value)}
								type="number"
								name="lwsJobSalary"
								id="lwsJobSalary"
								required
								className="!rounded-l-none !border-0"
								placeholder="20,00,000"
							/>
						</div>
					</div>

					<div className="fieldContainer">
						<label htmlFor="lwsJobDeadline">Deadline</label>
						<input
							value={deadline}
							onChange={(e) => setDeadline(e.target.value)}
							type="date"
							name="lwsJobDeadline"
							id="lwsJobDeadline"
							required
						/>
					</div>
					<div className="text-right">
						<input
							type="submit"
							value={editMode ? 'Edit' : 'Save'}
							className="lws-submit cursor-pointer btn btn-primary w-fit"
						/>
					</div>
				</form>
			</div>
		</>
	);
}
